/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AlbumOrderResponseDto,
  AllPurchasesResponseDto,
  AwsPresignedUrlDto,
  PurchasesResponseDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get track license purchases
 */
export const purchaseControllerGetPurchases = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<PurchasesResponseDto[]>(
    { url: `/purchase/list`, method: "GET", signal },
    options,
  );
};

export const getPurchaseControllerGetPurchasesQueryKey = () => {
  return [`/purchase/list`] as const;
};

export const getPurchaseControllerGetPurchasesQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPurchaseControllerGetPurchasesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof purchaseControllerGetPurchases>>
  > = ({ signal }) => purchaseControllerGetPurchases(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PurchaseControllerGetPurchasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof purchaseControllerGetPurchases>>
>;
export type PurchaseControllerGetPurchasesQueryError = ErrorType<unknown>;

export function usePurchaseControllerGetPurchases<
  TData = Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
          TError,
          Awaited<ReturnType<typeof purchaseControllerGetPurchases>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function usePurchaseControllerGetPurchases<
  TData = Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
          TError,
          Awaited<ReturnType<typeof purchaseControllerGetPurchases>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePurchaseControllerGetPurchases<
  TData = Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get track license purchases
 */

export function usePurchaseControllerGetPurchases<
  TData = Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetPurchases>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPurchaseControllerGetPurchasesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get album orders
 */
export const purchaseControllerGetAlbumOrders = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AlbumOrderResponseDto[]>(
    { url: `/purchase/albums`, method: "GET", signal },
    options,
  );
};

export const getPurchaseControllerGetAlbumOrdersQueryKey = () => {
  return [`/purchase/albums`] as const;
};

export const getPurchaseControllerGetAlbumOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPurchaseControllerGetAlbumOrdersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>
  > = ({ signal }) => purchaseControllerGetAlbumOrders(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PurchaseControllerGetAlbumOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>
>;
export type PurchaseControllerGetAlbumOrdersQueryError = ErrorType<unknown>;

export function usePurchaseControllerGetAlbumOrders<
  TData = Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
          TError,
          Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function usePurchaseControllerGetAlbumOrders<
  TData = Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
          TError,
          Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePurchaseControllerGetAlbumOrders<
  TData = Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get album orders
 */

export function usePurchaseControllerGetAlbumOrders<
  TData = Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetAlbumOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPurchaseControllerGetAlbumOrdersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all purchases (licenses + album orders)
 */
export const purchaseControllerGetAllPurchases = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AllPurchasesResponseDto>(
    { url: `/purchase/all`, method: "GET", signal },
    options,
  );
};

export const getPurchaseControllerGetAllPurchasesQueryKey = () => {
  return [`/purchase/all`] as const;
};

export const getPurchaseControllerGetAllPurchasesQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPurchaseControllerGetAllPurchasesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>
  > = ({ signal }) => purchaseControllerGetAllPurchases(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PurchaseControllerGetAllPurchasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>
>;
export type PurchaseControllerGetAllPurchasesQueryError = ErrorType<unknown>;

export function usePurchaseControllerGetAllPurchases<
  TData = Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
          TError,
          Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function usePurchaseControllerGetAllPurchases<
  TData = Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
          TError,
          Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePurchaseControllerGetAllPurchases<
  TData = Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all purchases (licenses + album orders)
 */

export function usePurchaseControllerGetAllPurchases<
  TData = Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof purchaseControllerGetAllPurchases>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getPurchaseControllerGetAllPurchasesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const purchaseControllerGetLicensePdf = (
  licenseId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<string>(
    { url: `/purchase/${licenseId}/pdf`, method: "POST", signal },
    options,
  );
};

export const getPurchaseControllerGetLicensePdfMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purchaseControllerGetLicensePdf>>,
    TError,
    { licenseId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof purchaseControllerGetLicensePdf>>,
  TError,
  { licenseId: string },
  TContext
> => {
  const mutationKey = ["purchaseControllerGetLicensePdf"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof purchaseControllerGetLicensePdf>>,
    { licenseId: string }
  > = (props) => {
    const { licenseId } = props ?? {};

    return purchaseControllerGetLicensePdf(licenseId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PurchaseControllerGetLicensePdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof purchaseControllerGetLicensePdf>>
>;

export type PurchaseControllerGetLicensePdfMutationError = ErrorType<unknown>;

export const usePurchaseControllerGetLicensePdf = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof purchaseControllerGetLicensePdf>>,
      TError,
      { licenseId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof purchaseControllerGetLicensePdf>>,
  TError,
  { licenseId: string },
  TContext
> => {
  const mutationOptions =
    getPurchaseControllerGetLicensePdfMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const purchaseControllerGetDownloadableAssets = (
  licenseId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<Blob>(
    {
      url: `/purchase/${licenseId}/download`,
      method: "POST",
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getPurchaseControllerGetDownloadableAssetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purchaseControllerGetDownloadableAssets>>,
    TError,
    { licenseId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof purchaseControllerGetDownloadableAssets>>,
  TError,
  { licenseId: string },
  TContext
> => {
  const mutationKey = ["purchaseControllerGetDownloadableAssets"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof purchaseControllerGetDownloadableAssets>>,
    { licenseId: string }
  > = (props) => {
    const { licenseId } = props ?? {};

    return purchaseControllerGetDownloadableAssets(licenseId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PurchaseControllerGetDownloadableAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof purchaseControllerGetDownloadableAssets>>
>;

export type PurchaseControllerGetDownloadableAssetsMutationError =
  ErrorType<unknown>;

export const usePurchaseControllerGetDownloadableAssets = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof purchaseControllerGetDownloadableAssets>>,
      TError,
      { licenseId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof purchaseControllerGetDownloadableAssets>>,
  TError,
  { licenseId: string },
  TContext
> => {
  const mutationOptions =
    getPurchaseControllerGetDownloadableAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Download all tracks from a purchased album as ZIP
 */
export const purchaseControllerGetAlbumDownload = (
  albumOrderId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<Blob>(
    {
      url: `/purchase/album/${albumOrderId}/download`,
      method: "POST",
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getPurchaseControllerGetAlbumDownloadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purchaseControllerGetAlbumDownload>>,
    TError,
    { albumOrderId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof purchaseControllerGetAlbumDownload>>,
  TError,
  { albumOrderId: string },
  TContext
> => {
  const mutationKey = ["purchaseControllerGetAlbumDownload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof purchaseControllerGetAlbumDownload>>,
    { albumOrderId: string }
  > = (props) => {
    const { albumOrderId } = props ?? {};

    return purchaseControllerGetAlbumDownload(albumOrderId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PurchaseControllerGetAlbumDownloadMutationResult = NonNullable<
  Awaited<ReturnType<typeof purchaseControllerGetAlbumDownload>>
>;

export type PurchaseControllerGetAlbumDownloadMutationError =
  ErrorType<unknown>;

/**
 * @summary Download all tracks from a purchased album as ZIP
 */
export const usePurchaseControllerGetAlbumDownload = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof purchaseControllerGetAlbumDownload>>,
      TError,
      { albumOrderId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof purchaseControllerGetAlbumDownload>>,
  TError,
  { albumOrderId: string },
  TContext
> => {
  const mutationOptions =
    getPurchaseControllerGetAlbumDownloadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Download all tracks from a purchased album as ZIP
 */
export const purchaseControllerGetAlbumDownloadNew = (
  albumOrderId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AwsPresignedUrlDto>(
    {
      url: `/purchase/album/${albumOrderId}/download/new`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getPurchaseControllerGetAlbumDownloadNewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purchaseControllerGetAlbumDownloadNew>>,
    TError,
    { albumOrderId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof purchaseControllerGetAlbumDownloadNew>>,
  TError,
  { albumOrderId: string },
  TContext
> => {
  const mutationKey = ["purchaseControllerGetAlbumDownloadNew"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof purchaseControllerGetAlbumDownloadNew>>,
    { albumOrderId: string }
  > = (props) => {
    const { albumOrderId } = props ?? {};

    return purchaseControllerGetAlbumDownloadNew(albumOrderId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PurchaseControllerGetAlbumDownloadNewMutationResult = NonNullable<
  Awaited<ReturnType<typeof purchaseControllerGetAlbumDownloadNew>>
>;

export type PurchaseControllerGetAlbumDownloadNewMutationError =
  ErrorType<unknown>;

/**
 * @summary Download all tracks from a purchased album as ZIP
 */
export const usePurchaseControllerGetAlbumDownloadNew = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof purchaseControllerGetAlbumDownloadNew>>,
      TError,
      { albumOrderId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof purchaseControllerGetAlbumDownloadNew>>,
  TError,
  { albumOrderId: string },
  TContext
> => {
  const mutationOptions =
    getPurchaseControllerGetAlbumDownloadNewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
